import { _js, ___p } from '@ifixit/utils/localize';

const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const MONTH = (DAY * 365) / 12;

/**
 * Format a comment's UNIX timestamp to match how the rest of the site phrases
 * relative dates (`Shared/realtime_date`'s relativeDate): "5 minutes ago" within
 * a month, an absolute locale date beyond it. Reimplemented here rather than
 * imported because that module references the legacy `onDomReady` global, which
 * isn't present in the standalone embed bundle (importing it crashes the bundle).
 * Kept output-identical so timestamps read the same as everywhere else.
 */
export function commentDate(unixSeconds: number | undefined): string {
   if (!unixSeconds) {
      return '';
   }
   const delta = Math.max(0, Date.now() - unixSeconds * 1000);

   if (delta < 15 * SECOND) {
      return _js('just now');
   }
   if (delta < MINUTE) {
      const n = Math.floor(delta / SECOND);
      return ___p(n, '%1 second ago', '%1 seconds ago', String(n));
   }
   if (delta < HOUR) {
      const n = Math.floor(delta / MINUTE);
      return ___p(n, '%1 minute ago', '%1 minutes ago', String(n));
   }
   if (delta < DAY) {
      const n = Math.floor(delta / HOUR);
      return ___p(n, '%1 hour ago', '%1 hours ago', String(n));
   }
   if (delta < MONTH) {
      const n = Math.floor(delta / DAY);
      return ___p(n, '%1 day ago', '%1 days ago', String(n));
   }
   return new Date(unixSeconds * 1000).toLocaleDateString(App.locale?.replace('_', '-'));
}
